import { AutogenModelOffPayee, AutogenRowOffPayee } from "./autogen/AutogenModelOffPayee";

export class ModelOffPayee extends AutogenModelOffPayee<RowOffPayee> {
	constructor() {
		super(RowOffPayee);
	}
}

export class RowOffPayee extends AutogenRowOffPayee {
}